"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplideSliderTeaserboxes = void 0;
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var splide_1 = __importDefault(require("@splidejs/splide"));
var constants_1 = require("../data/constants");
var constants_2 = require("../data/constants");
var SplideSlider = /** @class */ (function (_super) {
    __extends(SplideSlider, _super);
    function SplideSlider() {
        var _this = this;
        var _a;
        _this = _super.call(this, constants_1.DATA_SLIDER) || this;
        if (!_this.getElement())
            return _this;
        var main = document.querySelector('main');
        _this.setElement(main);
        (_a = _this.getChildElements("[".concat(constants_1.DATA_SLIDER, "]"))) === null || _a === void 0 ? void 0 : _a.forEach(function (slider) {
            if (slider.getAttribute('data-slider') == 'text-media') {
                var splide_2 = new splide_1.default(slider, {
                    type: 'slide',
                    rewind: false,
                    speed: 1000,
                    arrows: false,
                    autoplay: false,
                    perPage: 1,
                    mediaQuery: 'min',
                    pagination: false,
                    gap: '.5rem',
                    perMove: 1,
                    //lazyLoad: 'nearby',
                    breakpoints: {
                        768: {
                            arrows: true
                        }
                    }
                });
                splide_2.mount();
                splide_2.on('move', function () {
                    var currentActiveSlide = splide_2.root.querySelector('.is-active');
                    currentActiveSlide.classList.add('fade-out');
                    var allSlides = splide_2.root.querySelectorAll('.splide__slide');
                    allSlides.forEach(function (slide) {
                        if (!slide.classList.contains('fade-out')) {
                            slide.classList.add('fade-in');
                        }
                    });
                    var media = currentActiveSlide.querySelector('.img-fluid');
                    if (media.classList.contains('video')) {
                        var video = media;
                        video.pause();
                    }
                });
                splide_2.on('moved', function () {
                    var oldActiveSlide = splide_2.root.querySelector('.fade-out');
                    oldActiveSlide.classList.remove('fade-out');
                    var allSlides = splide_2.root.querySelectorAll('.splide__slide');
                    allSlides.forEach(function (slide) {
                        slide.classList.remove('fade-in');
                    });
                    // const newActiveSlide = splide.root.querySelector('.is-active');
                });
            }
            else if (slider.getAttribute('data-slider') == 'gallery') {
                if (parseInt(slider.getAttribute('data-slider-gallery-count')) == parseInt('2')) {
                    var splide_3 = new splide_1.default(slider, {
                        type: 'slide',
                        rewind: false,
                        speed: 1000,
                        arrows: false,
                        autoplay: false,
                        perPage: 1,
                        mediaQuery: 'min',
                        pagination: false,
                        gap: '.5rem',
                        perMove: 1,
                        //lazyLoad: 'nearby',
                        breakpoints: {
                            768: {
                                gap: '1.5rem',
                                drag: false,
                                perPage: 2
                            },
                            1024: {
                                arrows: true
                            },
                            1200: {
                                gap: '2rem'
                            }
                        }
                    });
                    splide_3.mount();
                    splide_3.on('move', function () {
                        var currentActiveSlide = splide_3.root.querySelector('.is-active');
                        currentActiveSlide.classList.add('fade-out');
                        var allSlides = splide_3.root.querySelectorAll('.splide__slide');
                        allSlides.forEach(function (slide) {
                            if (!slide.classList.contains('fade-out')) {
                                slide.classList.add('fade-in');
                            }
                        });
                        var media = currentActiveSlide.querySelector('.img-fluid');
                        if (media.classList.contains('video')) {
                            var video = media;
                            video.pause();
                        }
                    });
                    splide_3.on('moved', function () {
                        var oldActiveSlide = splide_3.root.querySelector('.fade-out');
                        oldActiveSlide.classList.remove('fade-out');
                        var allSlides = splide_3.root.querySelectorAll('.splide__slide');
                        allSlides.forEach(function (slide) {
                            slide.classList.remove('fade-in');
                        });
                        // const newActiveSlide = splide.root.querySelector('.is-active');
                    });
                }
                else if (parseInt(slider.getAttribute('data-slider-gallery-count')) > parseInt('2')) {
                    var splide_4 = new splide_1.default(slider, {
                        type: 'slide',
                        rewind: false,
                        speed: 1000,
                        arrows: false,
                        autoplay: false,
                        perPage: 1,
                        mediaQuery: 'min',
                        pagination: false,
                        gap: '.5rem',
                        perMove: 1,
                        //lazyLoad: 'nearby',
                        breakpoints: {
                            768: {
                                gap: '1.5rem',
                                perPage: 2
                            },
                            1024: {
                                arrows: true
                            },
                            1200: {
                                gap: '2rem'
                            }
                        }
                    });
                    splide_4.mount();
                    splide_4.on('move', function () {
                        var currentActiveSlide = splide_4.root.querySelector('.is-active');
                        currentActiveSlide.classList.add('fade-out');
                        var allSlides = splide_4.root.querySelectorAll('.splide__slide');
                        allSlides.forEach(function (slide) {
                            if (!slide.classList.contains('fade-out')) {
                                slide.classList.add('fade-in');
                            }
                        });
                        var media = currentActiveSlide.querySelector('.img-fluid');
                        if (media.classList.contains('video')) {
                            var video = media;
                            video.pause();
                        }
                    });
                    splide_4.on('moved', function () {
                        var oldActiveSlide = splide_4.root.querySelector('.fade-out');
                        oldActiveSlide.classList.remove('fade-out');
                        var allSlides = splide_4.root.querySelectorAll('.splide__slide');
                        allSlides.forEach(function (slide) {
                            slide.classList.remove('fade-in');
                        });
                        // const newActiveSlide = splide.root.querySelector('.is-active');
                    });
                }
            }
        });
        return _this;
    }
    return SplideSlider;
}(AbstractComponent_1.default));
exports.default = SplideSlider;
var SplideSliderTeaserboxes = /** @class */ (function (_super) {
    __extends(SplideSliderTeaserboxes, _super);
    function SplideSliderTeaserboxes() {
        var _this = this;
        var _a;
        _this = _super.call(this) || this;
        var main = document.querySelector('main');
        _this.setElement(main);
        (_a = _this.getChildElements("[".concat(constants_2.DATA_SLIDER_TEASERBOXES, "]"))) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
            // If only 3 elements
            if (element.getAttribute('data-slider-teaserboxes-count') == '3') {
                var splide = new splide_1.default(element, {
                    type: 'slide',
                    rewind: false,
                    speed: 350,
                    arrows: false,
                    pagination: true,
                    autoplay: false,
                    perMove: 1,
                    perPage: 1,
                    gap: '.5rem',
                    mediaQuery: 'min',
                    breakpoints: {
                        768: {
                            arrows: true,
                            drag: false,
                            perMove: 3,
                            perPage: 3,
                            gap: '1.5rem',
                        },
                        1180: {
                            perMove: 3,
                            perPage: 3,
                            gap: '2rem'
                        },
                    },
                    i18n: {
                        prev: 'Vorheriger Slide',
                        next: 'Nächster Slide',
                    }
                });
                splide.mount();
            }
            else {
                // More then 3 elements exist
                var splide = new splide_1.default(element, {
                    type: 'slide',
                    rewind: false,
                    speed: 350,
                    arrows: false,
                    pagination: true,
                    autoplay: false,
                    perMove: 1,
                    perPage: 1,
                    gap: '.5rem',
                    mediaQuery: 'min',
                    breakpoints: {
                        768: {
                            arrows: true,
                            perMove: 3,
                            perPage: 3,
                            gap: '1.5rem',
                        },
                        1180: {
                            perMove: 4,
                            perPage: 4,
                            gap: '2rem'
                        },
                    },
                    i18n: {
                        prev: 'Vorheriger Slide',
                        next: 'Nächster Slide',
                    }
                });
                splide.mount();
            }
        });
        return _this;
    }
    return SplideSliderTeaserboxes;
}(AbstractComponent_1.default));
exports.SplideSliderTeaserboxes = SplideSliderTeaserboxes;
